module.exports = __webpack_public_path__ + "img/mali.84148fde.png";